import { render, staticRenderFns } from "./NoticeAdministration.vue?vue&type=template&id=1ae5eee0"
import script from "./NoticeAdministration.vue?vue&type=script&lang=js"
export * from "./NoticeAdministration.vue?vue&type=script&lang=js"
import style0 from "./NoticeAdministration.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports